import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ObjectService {
  transform(obj, properties, propertyToExtract) {
    const copyObj = JSON.parse(JSON.stringify(obj));
    for (const key in copyObj) {
      if (Object.prototype.hasOwnProperty.call(copyObj, key)) {
        let value = '';
        if (properties.includes(key)) {
          const target = copyObj[key];
          if (target instanceof Array) {
            value = target
              .map((t) => t[propertyToExtract])
              .filter((t) => t)
              .reduce((a, b) => {
                a.push(b);
                return a;
              }, []);
          } else {
            value = target[propertyToExtract] || '';
          }
          copyObj[key] = value;
        }
      }
    }
    return copyObj;
  }

  clone(obj) {
    const stringified = JSON.stringify(obj);
    return JSON.parse(stringified);
  }

  randomRange(min: number = 1000, max: number = 10000000) {
    return ~~(Math.random() * (max - min + 1)) + min
  }

}
